/* eslint-disable react/no-array-index-key */
import React from 'react'
import moment from 'moment'

import { Expansible } from 'components/Expansible'
import { BGC_FIELDS, SCORE_PARTICIPANTS } from 'utils/constants/bgcFields'
import styles from './styles'
import BuildCompanyData from './BuildCompanyData'
import BuildFamilyRelations from './BuildFamilyRelations'
import BuildProcesses from './BuildProcesses'
import BuildRestrictions from './BuildRestrictions'
import BuildPep from './BuildPep'
import BuildNegativeMedia from './BuildNegativeMedia'
import BuildComplianceList from './BuildComplianceList'

const BgcExpansible = ({ field, bgc_info, score_data }) => {
  const classes = styles()

  const getTitle = () => {
    switch (field) {
      case BGC_FIELDS.job_role:
        return 'Cargo'
      case BGC_FIELDS.occupation_area:
        return 'Área de Ocupação'
      case BGC_FIELDS.negative_media:
        return 'Mídia Negativa'
      case BGC_FIELDS.pep:
        return 'PEP'
      case BGC_FIELDS.restriction_data:
        return 'Listas Restritivas'
      case BGC_FIELDS.process_data:
        return 'Processos Judiciais'
      case BGC_FIELDS.family_relation_data:
        return 'Vínculos Familiares'
      case BGC_FIELDS.company_data:
        return 'Participações Societárias'
      case BGC_FIELDS.compliance_list:
        return 'Compliance List'
      default:
        return 'N/A'
    }
  }

  return (
    <Expansible open={false} title={getTitle()}>
      {bgc_info ? (
        <div
          className={
            field === BGC_FIELDS.negative_media ? classes.midia : classes.info
          }
        >
          {field === BGC_FIELDS.negative_media && (
            <BuildNegativeMedia negativeMediaData={bgc_info} />
          )}

          {field === BGC_FIELDS.pep && <BuildPep pepData={bgc_info} />}

          {field === BGC_FIELDS.restriction_data && (
            <BuildRestrictions restrictionsData={bgc_info} />
          )}

          {field === BGC_FIELDS.process_data && (
            <BuildProcesses processData={bgc_info} />
          )}

          {field === BGC_FIELDS.family_relation_data && (
            <BuildFamilyRelations familyRelationsData={bgc_info} />
          )}

          {field === BGC_FIELDS.company_data && (
            <BuildCompanyData companyData={bgc_info} />
          )}

          {field === BGC_FIELDS.compliance_list && (
            <BuildComplianceList complianceListData={bgc_info} />
          )}

          <div className={classes.score}>
            {SCORE_PARTICIPANTS.includes(field) ? (
              <div>
                <strong>Pontuação parcial: </strong>
                {`
                      ${
                        score_data && score_data.value ? score_data.value : 0
                      } pontos`}
              </div>
            ) : (
              <div />
            )}

            <span>
              <strong>Última atualização: </strong>{' '}
              {bgc_info.updated
                ? moment(bgc_info.updated).format('DD/MM/YYYY HH:MM')
                : 'N/A'}
            </span>
          </div>
        </div>
      ) : (
        <div className={classes.expansibleContent}>
          <span>Nenhuma informação encontrada.</span>
        </div>
      )}
    </Expansible>
  )
}

export default BgcExpansible
